import { useMemo } from 'react';
import { DEFAULT_FILTER as MAIN_DEFAULT_FILTER } from '../Main/SesionApp';
import { DEFAULT_FILTER as DETALLES_DEFAULT_FILTER } from '../Detalles/SesionDetalles';

export const useUrlParams = () => {
  return useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    
    const primeraInfancia = urlParams.get('primerainfancia') === '1';
    const idsParam = urlParams.get('ids');
    const tiposClasificadores = urlParams.get('tiposclasificadores');
    const anios = urlParams.get('anios');
    const ids = idsParam ? idsParam.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id)) : [];
    
    // Asignar el valor de primerainfancia a ambos DEFAULT_FILTER
    const valueToAssign = primeraInfancia ? '1' : '';
    const valueToAssignTiposClasificadores = tiposClasificadores ? tiposClasificadores : '';
    const valueToAssignAnios = anios ? anios : '';
    
    MAIN_DEFAULT_FILTER.primerainfancia = valueToAssign;
    MAIN_DEFAULT_FILTER.tiposClasificadores = valueToAssignTiposClasificadores;
    MAIN_DEFAULT_FILTER.anios = valueToAssignAnios;

    DETALLES_DEFAULT_FILTER.primerainfancia = valueToAssign;
    DETALLES_DEFAULT_FILTER.tiposClasificadores = valueToAssignTiposClasificadores;
    DETALLES_DEFAULT_FILTER.anios = valueToAssignAnios;
    
    console.log('URL Params detectados:', { primeraInfancia, valueToAssign, ids });
    console.log('DEFAULT_FILTER.primerainfancia asignado:', valueToAssign);
    console.log('DEFAULT_FILTER.tiposClasificadores asignado:', DETALLES_DEFAULT_FILTER.tiposClasificadores);
    
    return {
      primeraInfancia,
      ids,
      hasUrlParams: primeraInfancia || ids.length > 0,
      tiposClasificadores
    };
  }, []);
};